import antdFr from "antd/locale/fr_FR";
import frMessages from "../locales/fr_FR.json";

const frLang = {
  messages: {
    ...frMessages
  },
  antd: antdFr,
  locale: 'fr'
};
export default frLang;
